import angular from "angular";
import { saveAs } from "file-saver/FileSaver";
import Sortable from "sortablejs";

let TargetListController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  Target,
  Toast
) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit,
    orderList,
    showCreateDialog,
    handleDelete,
  });

  activate();

  function activate() {
    $ctrl.parentGroupId = $state.params.parent_group_id;

    $ctrl.resources = {
      count: 0,
      data: [],
    };

    $ctrl.uiState = "LOADING";

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: "updated_at DESC",
      like_search: "",
      like_search_fields: ["name"],
    };

    if (!$ctrl.parentGroupId) {
      $ctrl.$scope.tableConfig.like_search_fields.push("$parent_group.name$");
    }

    $ctrl.$scope.$watch(
      "tableConfig",
      () => {
        loadData();
      },
      true
    );

    createSortableList();
  }

  function createSortableList() {
    const el = document.getElementById("items");
    const sortable = Sortable.create(el, { onUpdate: reorderListItems });
  }

  function reorderListItems(event) {
    const { oldIndex, newIndex } = event;
    const listCopy = angular.copy($ctrl.resources.data);
    const id = event.item.getAttribute("data-id");

    Target.updatePosition(id, {
      new_position: listCopy[newIndex].position,
      old_position: listCopy[oldIndex].position,
    })
      .then(function (res) {
        Toast.success($filter('translate')('table-list-new-order'));
      })
      .catch(({ data }) => {
        Toast.error(data.message);
      })
      .finally(() => loadData());

    const elementToMove = $ctrl.resources.data.splice(oldIndex, 1);
    $ctrl.resources.data.splice(newIndex, 0, elementToMove[0]);
  }

  $scope.downloadReport = function () {
    $ctrl.activeSpin = true;
    $ctrl.activeSpinButton = true;
    Target.downloadReport()
      .then(function (res) {
        var file = new Blob([res], { type: "text/csv;charset=utf-8;" });
        let messageSuccess = $filter("translate")("report-success");
        $ctrl.activeSpin = false;
        $ctrl.activeSpinButton = false;
        Toast.success(messageSuccess);
        saveAs(file, "rel_analitico_categorias.csv");
      })
      .catch((err) => {
        console.log("err:", err);
        let messageError = $filter("translate")("report-error");
        $ctrl.activeSpin = false;
        $ctrl.activeSpinButton = false;
        Toast.error(messageError);
      });
  };

  function edit(event, target) {
    showCreateDialog(event, target);
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog
      .confirm()
      .textContent($filter("translate")("common-detail-delete-confirm-text"))
      .ariaLabel($filter("translate")("common-detail-delete-confirm-text"))
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Target.destroy(resource)
          .then((response) => {
            Toast.success($filter("translate")("common-detail-delete-success"));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
            console.log("err:", err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {});
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(" ")[0];
      var currentOrder = tableConfig.order.split(" ")[1];

      if (currentField === field) {
        currentOrder = currentOrder === "DESC" ? "ASC" : "DESC";
        tableConfig.order = currentField + " " + currentOrder;
      } else {
        tableConfig.order = field + " " + "ASC";
      }
    } else {
      tableConfig.order = field + " " + " ASC";
    }
  }

  function showCreateDialog(event, selectedTarget) {
    $ctrl.selectedTarget = selectedTarget;

    let contentText = $ctrl.parentGroupId
      ? "'target-list-create-dialog-content'"
      : "'target-list-create-category-dialog-content'";
    let dialog = {
      controller: DialogController,
      targetEvent: event,
      template:
        '<md-dialog aria-label="List dialog">' +
        '  <form name="targetGroupForm" ng-cloak ng-submit="saveResource(targetGroup)">' +
        '  <md-dialog-content class="layout-padding">' +
        '  <div class="md-dialog-content" >' +
        "    <h2>{{ 'common-new-masculine' | translate }}</h2>" +
        "" +
        "    <p>{{" +
        contentText +
        "| translate }}</p>" +
        "" +
        '    <md-input-container class="md-block" flex>' +
        "      <label>{{ 'target-list-create-dialog-name-input-label' | translate }}</label>" +
        "" +
        '      <input ng-model="targetGroup.name" required>' +
        "    </md-input-container>",
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false,
    };

    if (!$ctrl.parentGroupId) {
      dialog.template +=
        "" +
        '    <md-input-container class="md-block" flex>' +
        "      <label>{{ 'target-list-create-dialog-target-select-label' | translate }}</label>" +
        "" +
        '      <md-select ng-model="targetGroup.topLevelId" required' +
        '                 ng-change="loadCategories(targetGroup.topLevelId)">' +
        '        <md-option ng-repeat="group in targetGroups" ' +
        '                   ng-value="group.id">' +
        "          {{ group.name }}" +
        "        </md-option>" +
        "      </md-select>" +
        "    </md-input-container>" +
        "" +
        '    <md-input-container class="md-block" flex>' +
        "      <label>{{ 'target-list-create-dialog-category-select-label' | translate }}</label>" +
        "" +
        '      <md-select ng-model="targetGroup.categoryId"' +
        '                 ng-disabled="loading">' +
        '        <md-option ng-value="null" >' +
        "          {{ 'common-none-feminine' | translate }}" +
        "        </md-option>" +
        "        <md-option ng-repeat=\"category in parentCategories | filter:{ id: '!' + targetGroup.id}\"" +
        '                 ng-value="category.id" >' +
        "          {{ category.name }}" +
        "        </md-option>" +
        "      </md-select>" +
        "" +
        '      <div class="hint" ng-show="false">' +
        "        {{ 'target-list-create-dialog-category-select-hint' | translate}}" +
        "      </div>" +
        "    </md-input-container>";
    }

    dialog.template +=
      "" +
      "    </div>" +
      "    </md-dialog-content>" +
      "  <md-dialog-actions>" +
      '    <md-button ng-click="cancel()">' +
      "      {{ 'common-cancel' | translate }}" +
      "    </md-button>" +
      "" +
      '    <md-button type="submit"' +
      '               ng-disabled="!targetGroupForm.$valid" class="md-accent">' +
      "      {{ 'common-save-button-text' | translate }}" +
      "    </md-button>" +
      "  </md-dialog-actions>" +
      "  </form>" +
      "</md-dialog>";

    $ctrl.promise = loadTargetGroups({
      parent_group_id: "null",
    })
      .then((targetGroups) => {
        $ctrl.targetGroups = targetGroups;

        $mdDialog.show(dialog).then(
          (newTargetGroup) => {
            newTargetGroup.parent_group_id =
              newTargetGroup.categoryId || newTargetGroup.topLevelId;
            delete newTargetGroup.categoryId;
            delete newTargetGroup.topLevelId;
            save(newTargetGroup);
          },
          () => {}
        );
      })
      .catch((err) => {
        console.log("err:", err);
      });
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";

    $scope.targetGroup = $ctrl.selectedTarget || {};

    $scope.loadCategories = function (parentGroupId) {
      $scope.loading = true;
      $scope.parentCategories = [];
      loadTargetGroups({
        parent_group_id: parentGroupId,
      })
        .then((result) => {
          $scope.parentCategories = result;
          $scope.loading = false;
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.uiState = "ERROR";
          $scope.loading = false;
        });
    };

    if (
      _.isEmpty($scope.targetGroup && $scope.targetGroup.parent_group) === false
    ) {
      let target = $scope.targetGroup;
      $scope.targetGroup.topLevelId = target.parent_group.parent_group
        ? target.parent_group.parent_group.id
        : target.parent_group.id;

      $scope.loadCategories($scope.targetGroup.topLevelId);

      $scope.targetGroup.categoryId = target.parent_group.id;
    }

    $scope.targetGroups = $ctrl.targetGroups;
    $scope.parentCategories = [];

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.saveResource = function (targetGroup) {
      $mdDialog.hide(targetGroup);
    };
  }

  // Local functions

  function loadTargetGroups(query) {
    return Target.index(query);
  }

  function loadData() {
    angular.extend($ctrl.$scope.tableConfig, $state.params);

    $ctrl.promise = Target.load($ctrl.$scope.tableConfig)
      .then((response) => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
        $ctrl.$scope.$apply();
      })
      .catch((err) => {
        console.log("err:", err);
        $ctrl.uiState = "ERROR";
      });
  }

  function setPlaceHolderValues(arr) {
    _.forEach(arr, (item) => {
      if (item.description === null || item.description === undefined) {
        item.description = $filter("translate")("common-not-informed");
      }
    });
  }

  function save(target) {
    $ctrl.promise = Target.save(target)
      .then((response) => {
        loadData();
        Toast.success($filter("translate")("target-detail-save-success"));
      })
      .catch((err) => {
        loadData();
        let defaultErrMsg = "common-server-error";
        if (err.status == 409) {
          let fourONineMsg = $ctrl.parentGroupId
            ? $filter("translate")("target-detail-409-error")
            : "A categoria já existe!";
          $mdDialog.show(
            $mdDialog
              .alert()
              .clickOutsideToClose(true)
              .textContent(fourONineMsg)
              .ok("Ok")
          );
        } else {
          Toast.error($filter("translate")(defaultErrMsg));
        }
      });
  }
};

TargetListController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "Target",
  "Toast",
];

export default TargetListController;



// WEBPACK FOOTER //
// ./client/app/components/target/target-list.controller.js